import { FC, ReactNode, useRef } from 'react'
import { motion, useInView } from 'framer-motion'
import styled from 'styled-components/macro'

import { theme } from 'styles/theme'

export const FigCaption = styled.figcaption``

type Props = {
  FigCaptionComponent: typeof FigCaption | string
  description: ReactNode
}

export const AnimatedFigcaption: FC<Props> = ({
  FigCaptionComponent,
  description,
}) => {
  const ref = useRef(null)
  const isInView = useInView(ref, { amount: 'all' })

  return (
    <FigCaption as={FigCaptionComponent} ref={ref}>
      <motion.div
        animate={{ opacity: isInView ? 1 : 0 }}
        transition={{
          delay: 0.7,
          duration: 0.6,
          ease: theme.easeValues.inOut,
        }}
      >
        {description}
      </motion.div>
      <motion.span
        animate={{ scale: isInView ? 1 : 0 }}
        transition={{
          type: 'spring',
          delay: 0.3,
          damping: 20,
          stiffness: 800,
        }}
      />
    </FigCaption>
  )
}
